import styled from 'styled-components/macro';

import {
    Button,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
} from "@chakra-ui/react";
import {loadStripe} from '@stripe/stripe-js/pure';
import {Elements} from "@stripe/react-stripe-js";
import CheckoutForm from "./CheckoutForm";
import {useModal, useSettings} from "../../store";
import {useFeedback} from "../../store/feedback";
import {useCreateCardPayment} from "../../api/payments";
import {useEffect, useState} from "react";
import SuccessfulPurchase from "./successful_purchase";

const Terms = styled.div``;

const PayWithCard = styled(({className, onClose, type, tier = 1, awards = 1, overridePrice}) => {
    const stripePromise = loadStripe("pk_live_51Lb99DBskTIWjE9dBIDuIb0NmRSKwHIhvoovmiYALJGoD7b46iJgiGxWDyt8MuToWkV4ZnM8rsTMvm6KtrWB84QI00edqppcYV");
    const modal = useModal();
    const price = type === "award" ? 3.99 * awards : overridePrice;
    const {error, feedbackCh} = useFeedback();
    const [success, setSuccess] = useState(false);
    const [saved, setSaved] = useState(0);
    const cardPayment = useCreateCardPayment(feedbackCh, type, tier, awards, price);
    const id = cardPayment?.token;
    const {theme} = useSettings();
    const appearance = {
        theme: "stripe",
        variables: {
            colorPrimary: '#0570de',
            colorBackground: `${theme === 'dark' ? '#1a1a1b' : '#fff'}`,
            colorText: `${theme === 'dark' ? '#fff' : '#000'}`,
        }
    };
    const options = {
        // passing the client secret obtained from the server
        clientSecret: id,
        disableLink: true,
        wallets: 'never',
        appearance,
    };
    const handleClick = () => {
        setSaved(Date.now());
    };

    useEffect(() => {
        if (success) {
            onClose();
            modal.open(SuccessfulPurchase);
        }
    }, [success]);

    return (
        <Modal
            isOpen
            onClose={onClose}
        >
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Send Payment</ModalHeader>
                <ModalCloseButton />
                <ModalBody pb={6} className={className}>

                    {id ?
                        <Elements stripe={stripePromise} options={options} >
                            <CheckoutForm saved={saved} setSuccess={setSuccess}/>
                        </Elements>
                        :
                        <>Loading...</>
                    }

                    <Terms>By placing your order, you are signing up to a {type === "award" ? "one time payment" : "recurring monthly charge"} of ${price} USD, and agreeing to our Terms of Service.</Terms>

                </ModalBody>
                <ModalFooter>

                    <Button variant="cancel" mr={3} onClick={onClose}>Close</Button>
                    <Button type='submit' variant="blue" onClick={handleClick}>
                        Buy
                    </Button>

                </ModalFooter>
            </ModalContent>
        </Modal>
    )})`
  ${Terms} {
    font-size: 14px;
    margin-top: 24px;
  }
`;

export default PayWithCard;